/** Small shared helpers for components. */

/** Joins class names, skipping falsy values. */
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ")
}
